import * as React from "react";
import "./ignoreTransactionModal.scss"
import Transaction, {ReconciliationStatus} from "../../../../model/transaction/Transaction";
import Modal from "../../../ui/modal/Modal";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Toast from "../../../helper/Toast";
import {api} from "../../../../api/api";
import TextArea from "../../../../hiberUiKit/src/atoms/TextArea/TextArea";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";


interface IProps {
	/**
	 * Transaction to be ignored/unignored.
	 */
	transaction: Transaction;
	/**
	 * On close callback
	 */
	onClose: () => void;
	/**
	 * Successful ignore/unignore callback
	 */
	onSuccess: () => void;
}

interface IState {
	/**
	 * Note to be created for transaction, containing reason of ignore/unignore.
	 */
	noteContent: string;
}

export default class IgnoreTransactionModal extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {noteContent: ""};
	}

	render() {
		const transactionIgnored = this.props.transaction.reconciliationStatus === ReconciliationStatus.IGNORED;
		let modalTitle, actionType, submitButtonLabel;
		if (transactionIgnored) {
			modalTitle = "Revert ignored transaction?";
			actionType = "reversal";
			submitButtonLabel = "Revert"
		}
		else {
			modalTitle = "Ignore transaction?";
			actionType = "ignoring this transaction";
			submitButtonLabel = "Ignore transaction";
		}

		return (
			<Modal onCloseClicked={this.props.onClose} title={modalTitle} autoWidth={true} customClass="c-ignore-modal">
				<div className="c-ignore-modal_content-container">
					<div className="c-ignore-modal_bold-text">You must provide a reason for {actionType}.</div>
					<TextArea value={this.state.noteContent}
							  placeholder={"Enter reason"}
							  onChange={this.onChange}
							  rows={4}
							  hasBorder
							  autoSize/>
				</div>
				<div className="c-ignore-modal_buttons-container">
					<div className="c-ignore-modal_buttons-container_buttons">
						<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
						<ButtonPrimary label={submitButtonLabel}
									   disabled={!this.state.noteContent.trim().length}
									   onClick={() => this.onSubmit(transactionIgnored)}/>
					</div>
				</div>
			</Modal>
		);
	}

	onChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => this.setState({noteContent: evt.target.value});

	onSubmit = (transactionIgnored: boolean) => transactionIgnored ? this.unignoreTransaction() : this.ignoreTransaction();

	ignoreTransaction = () => {
		api.instance.transactionApi.ignoreTransaction(this.props.transaction.id)
			.then(() => {
				Toast.success("Transaction ignored successfully", "Ignore transaction");
				this.addNote();
				this.props.onSuccess();
			})
			.catch(error => notifyBugsnagAndShowToast(error, "Ignore transaction"));
	};

	unignoreTransaction = () => {
		api.instance.transactionApi.undoIgnoreTransaction(this.props.transaction.id)
			.then(() => {
				Toast.success("Transaction unignored successfully", "Unignore transaction");
				this.addNote();
				this.props.onSuccess();
			})
			.catch(error => notifyBugsnagAndShowToast(error, "Unignore transaction"));
	};

	addNote = () => api.instance.noteApi.createTransactionNote(this.props.transaction.id, this.state.noteContent)
		.catch(error => notifyBugsnagAndShowToast(error, "Create note"));
}
